module.exports = __webpack_public_path__ + "static/media/password.43fdc076.svg";